import LandingFooter from './LandingFooter';
export default LandingFooter;
